///////////////////////////////////////////////////

import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';
import type { LimitOrderThunks } from 'state/secondaryMarket/limit-order/limitOrder.thunk';
import type { LiveThunks } from 'state/secondaryMarket/live/live.thunk';
import type { EpicWithThunk } from 'state/state.common';
import type { SecondaryMarketQuotesTabType } from 'state/workspaces/model';

export function loadAfterTabContentFetchedEpic(
  handledTabType: Exclude<SecondaryMarketQuotesTabType, 'closePriceOrder' | 'realtimeQuote'>,
  reloadTabThunk: LimitOrderThunks['reloadTabThunk'] | LiveThunks['reloadTabThunk'],
): EpicWithThunk {
  return actions$ => {
    return actions$.pipe(
      ofType('WORKSPACE_TAB_CONTENT_FETCHED'),
      filter(({ workspace, tabType }) => workspace === 'secondaryMarketQuotes' && tabType === handledTabType),
      mergeMap(({ tabId }) => of(reloadTabThunk(tabId))),
    );
  };
}
